import MainContentDetail from "../components/content-detail/main-detail";

function DetailContent() {
  return (
    <div className="w-[95%] mx-auto">
        
      <MainContentDetail />
    </div>
  );
}

export default DetailContent;